import styles, { css } from 'styled-components';

export const Box = styles.div`
    position: relative;
`;

type Props = {
    $active: boolean;
}

export const ImageBox = styles.img<Props>`
    position: absolute;

    width: 40px;
    height: 40px;
    transform: translateX(-50%);
    visibility: hidden;
    opacity: 1;
    top: 0px;

    transition-property: all;
    transition-duration: 600ms;

    ${({ $active }) => $active && css`
        visibility: visible;
        top: -50px;
        opacity: 0;
    `}
`;
